<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Purchase List</h2>
        </div>
          <div class="card flex flex-row gap-4 flex-wrap">

           <div>
                    <label for="startDate" class="block text-sm font-medium text-gray-700 ">From Date</label>
                    <input type="date" id="startDate" v-model="filter.startDate" class="w-full p-2 border border-gray-300 rounded " />
            </div>

         <div>
                    <label for="endDate" class="block text-sm font-medium text-gray-700 ">To Date</label>
                    <input type="date" id="endDate"  v-model="filter.endDate" class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded " />
            </div>



                                   <div>
                                            <label for="vendor" class="form-label">Search Vendor</label><br>
                                            <select class="form-select form-select-sm" id="vendor" ref="vendor" v-model="filter.vendorid">
                                                <option value=""></option>
                                                <option v-for="(item, index) in vendorList" :key="index" :value="item.id"> {{ item.name }} / {{ item.cell }}</option>
                                            </select>
                                        </div>




             <div class="mt-3">
                 <button type="submit" @click="getFilterBasics" class="btn btn-primary-solid px-5 mt-2 ml-4 mb-2 lg:mt-5 lg:ml-3 w-full lg:w-auto cursor-pointer">
                        Filter
                    </button>
                </div>


                    <div class="">
                        <label for="" class="form-label">Bill No *</label>
                        <input type="number" id="barcode" v-model="filterwise.billno"  @input="onBillNoChange" placeholder="Type Here Bill No."
                            class="form-input" required autocomplete="off">
                    </div>


        </div>



        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <table id="datatable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Bill No</th>
                                    <th class="bg-[#B2E8D9]">Date</th>
                                    <th class="bg-[#B2E8D9]">Vendor Name</th>
                                    <th class="bg-[#B2E8D9]">Total</th>
                                    <th class="bg-[#B2E8D9]">Paid</th>
                                    <th class="bg-[#B2E8D9]">GST</th>
                                    <th class="bg-[#B2E8D9]">Note</th>
                                    <th class="bg-[#B2E8D9]">Operation</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in PurchaseList" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.entry_date}}</td>
                                    <td>{{item.vend_name}} <span v-if="item.invoice_number > 0">/{{ item.invoice_number }}</span></td>
                                    <td class="text-danger">{{item.total}}</td>
                                    <td class="text-info">{{item.paid}}</td>
                                    <td>{{item.gst}}</td>
                                    <td>{{item.remark}}</td>
                                     <td>
                                                <button class="btn-icon btn-danger-icon-light size-7" @click="showmodal(item.id)" >
                                           <i class="ri-eye-line text-primary text-[13px]"></i>
                                        </button>
                                    </td>
                                </tr> 
                            </tbody>
                              <tfoot class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr style="background:rgb(226 232 240 / 0.5)">
                                    <td colspan="3"></td>
                                    <td class="text-danger">{{Final.total}}</td>
                                    <td class="text-info">{{Final.paid}}</td>

                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->


<!-- orders modal -->
 <!-- Modal -->
<div v-if="showModel" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-2xl shadow-lg w-full max-w-md mx-auto">
    <div class="flex justify-between items-center p-4 border-b">
      <h2 class="text-lg font-semibold">Purchase Iteams</h2>
      <button @click="closeModel" class="text-gray-500 hover:text-gray-700 text-2xl leading-none">&times;</button>
    </div>
    

  <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <table id="datatable2" class="datatable2">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Sr</th>
                                    <th class="bg-[#B2E8D9]">Product Name</th>
                                    <th class="bg-[#B2E8D9]">Qty</th>
                                   
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in purchaseListIteams" :key="item.id">
                                    <td>{{index+1}}</td>
                                    <td>{{item.prd_name}}</td>
                                    <td>{{item.qty}}</td>
                                   
                                 
                                </tr> 
                            </tbody>
                           
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>









    <div class="flex justify-end gap-2 p-4 border-t">
      <!-- <button class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
        Save changes
      </button> -->
    </div>
  </div>
</div>
 <!-- orders modal -->
















</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'PurchaseList',
components: {
 
} ,
mounted(){
 this.getBasics();
},
data() {
     const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     PurchaseList:[],
     datatable:null,
     product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
     filter:{
        startDate:this.getStartDate(),
        endDate:today,
        vendorid:''
     },

     vendorList:[],
       Final:{total:0,paid:0},
       showModel:false,
       purchaseListIteams:[],

 filterwise:{
        billno:'',
    },



 }
 }, 
methods:{
      getStartDate() {
      let startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      //startDate.setDate(1); // Set to the 1st of the month
      return startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    },
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getPurchases').then(function (response) {
             self.destroyDatatble();
                 self.PurchaseList=response.data.purchaseList;
                 self.employees=response.data.userDetails;
                 self.vendorList=response.data.vendorList;
                }).then(()=>{ 

              self.refreshDatatble();
               self.calculateTotal();



            $("#vendor").select2({
                                                width: '250px', 
                                                placeholder:"Search Vendor Here...",
                                            "language": {
                                                        "noResults": function(){
                                                            return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                        }
                                                    },
                                                        escapeMarkup: function (markup) {
                                                            return markup;
                                                        }
                                            }).on('change', function (event) {
                                            //  alert(event.target.value);
                                                    self.filter.vendorid=event.target.value; 
                                                            
                                                    
                                                    
                                                // self.calculateTotals();            
                                                    
                                                });








              
                    });;
  }, 
            delete_category() {
                var self = this; 
                axios.post('deleteProduct', {deleteId:this.deleteId})
                    .then(response => {
                        self.PurchaseList=response.data.products;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },




        refreshDatatble() {
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false,
                            "order": [] 
                            });


        self.datatable= $(".datatable2").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false 
                            });

                },
          destroyDatatble() {
                 if ($.fn.dataTable.isDataTable('.datatable')) {
                        $('.datatable').DataTable().destroy();
                    }
                     if ($.fn.dataTable.isDataTable('.datatable2')) {
                        $('.datatable2').DataTable().destroy();
                    }
          },



async getFilterBasics() {
       var self=this;
         axios.post('getFilterPurchases',self.filter).then(function (response) {
             self.destroyDatatble();
                 self.PurchaseList=response.data.purchaseList;
                 self.employees=response.data.userDetails;
                 self.vendorList=response.data.vendorList;
                }).then(()=>{ 
                    
              self.refreshDatatble();
              
                    });;
  }, 

    calculateTotal(){
            var self=this;
            self.Final=  {total:0,paid:0};


                Array.from(self.PurchaseList).forEach((row) => {
                self.Final.total+=parseFloat(row.total);
                self.Final.paid+=parseFloat(row.paid);
                });
            },







            showmodal(id){
                var self=this;


                axios.post('getPurchasesIteams',{id:id}).then(function (response) {
                    self.destroyDatatble();
                        self.PurchaseList=response.data.purchaseList;
                        self.employees=response.data.userDetails;
                        self.vendorList=response.data.vendorList;
                        self.purchaseListIteams=response.data.purchaseListIteams;
                        }).then(()=>{
                          self.refreshDatatble();
                            
                    });;

                self.showModel=true;






            },


             closeModel() {
    this.showModel = false;
  },







  onBillNoChange() {

  var self=this;
         axios.post('getFilterWisePurchases',self.filterwise).then(function (response) {
             self.destroyDatatble();
                 self.PurchaseList=response.data.purchaseList;
                 self.employees=response.data.userDetails;
                 self.vendorList=response.data.vendorList;
                }).then(()=>{ 
                    
              self.refreshDatatble();
              
                    });
 
    }







}
}
</script>
